import React from "react";
import "../styles/HoverComponent.scss";

export function HoverComponent(props) {
  const { description, githubUrl, projectUrl, title } = props.project;

  return (
    <div className="hover">
      <div className="description">{description}</div>
      <div className="lower-section">
        <div className="project-heading">
          <h5>{title}</h5>
          <div className="line-decoration"></div>
        </div>
        <div className="project-links">
          <a href={githubUrl} target="_blank" rel="noopener noreferrer">
            Github
          </a>
          <a href={projectUrl} target="_blank" rel="noopener noreferrer">
            Explore
          </a>
        </div>
      </div>
    </div>
  );
}
